(() => {
  'use strict';
  if (window.BuyonikPaperCatalogue) return;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  function filter(root) {
    const category = root.querySelector('[data-paper-filter][aria-pressed="true"]')?.dataset.paperFilter || 'all';
    const search = normalize(root.querySelector('[data-paper-search]').value);
    const order = root.querySelector('[data-paper-sort]').value;
    const cards = [...root.querySelectorAll('[data-paper-card]')];
    let count = 0, formats = 0;
    cards.forEach(card => {
      const panels = [...card.querySelectorAll('[data-paper-panel]')];
      const matches = (category === 'all' || category === card.dataset.paperCard) && (!search || panels.some(panel => normalize(panel.dataset.search).includes(search)));
      card.hidden = !matches;
      if (matches) { count++; formats += panels.length; }
      card.dataset.price = card.querySelector('[data-paper-panel]:not([hidden])')?.dataset.price || '0';
    });
    cards.sort((a, b) => order === 'price_up' ? Number(a.dataset.price) - Number(b.dataset.price) : order === 'price_down' ? Number(b.dataset.price) - Number(a.dataset.price) : order === 'az' ? a.dataset.paperTitle.localeCompare(b.dataset.paperTitle, document.documentElement.lang) : Number(a.dataset.position) - Number(b.dataset.position));
    const grid = root.querySelector('[data-paper-grid]');
    cards.forEach(card => grid.append(card));
    const counter = root.querySelector('[data-paper-count]');
    counter.textContent = `${count} ${counter.dataset.results} · ${formats} ${counter.dataset.formats}`;
    root.querySelector('[data-paper-empty]').hidden = count !== 0;
  }
  function legacyCategory(root) {
    if (!root.closest('[data-merchant-shop]')) return;
    const category = location.hash === '#selection-thermique' ? 'thermal' : location.hash === '#selection-bond' ? 'bond' : 'all';
    root.querySelectorAll('[data-paper-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.paperFilter === category)));
  }
  function init() {
    document.querySelectorAll('[data-paper-catalogue]:not([data-paper-ready])').forEach(root => {
      root.dataset.paperReady = 'true';
      root.querySelectorAll('[data-paper-card]').forEach((card, index) => { card.dataset.position = String(index); });
      legacyCategory(root);
      filter(root);
    });
  }
  document.addEventListener('click', event => {
    const size = event.target.closest('[data-paper-size]');
    if (size) {
      const card = size.closest('[data-paper-card]');
      const next = [...card.querySelectorAll('[data-paper-panel]')].find(panel => panel.dataset.paperPanel === size.dataset.paperSize);
      if (!next || !next.hidden) return;
      const top = size.getBoundingClientRect().top;
      card.querySelectorAll('[data-paper-panel]').forEach(panel => { panel.hidden = panel !== next; });
      card.dataset.price = next.dataset.price || '0';
      const selected = next.querySelector(`[data-paper-size="${size.dataset.paperSize}"]`);
      selected.focus({ preventScroll: true });
      card.dispatchEvent(new CustomEvent('buyonik:format-change', { bubbles: true }));
      const offset = selected.getBoundingClientRect().top - top;
      if (Math.abs(offset) > 0.5) window.scrollBy({ top: offset, left: 0, behavior: 'instant' });
      return;
    }
    const button = event.target.closest('[data-paper-filter], [data-paper-reset]');
    if (!button) return;
    const root = button.closest('[data-paper-catalogue]');
    const reset = button.hasAttribute('data-paper-reset');
    root.querySelectorAll('[data-paper-filter]').forEach(item => item.setAttribute('aria-pressed', String(reset ? item.dataset.paperFilter === 'all' : item === button)));
    if (reset) { root.querySelector('[data-paper-search]').value = ''; root.querySelector('[data-paper-sort]').value = 'selection'; }
    filter(root);
  });
  document.addEventListener('input', event => { if (event.target.matches('[data-paper-search]')) filter(event.target.closest('[data-paper-catalogue]')); });
  document.addEventListener('change', event => { if (event.target.matches('[data-paper-sort]')) filter(event.target.closest('[data-paper-catalogue]')); });
  window.addEventListener('hashchange', () => document.querySelectorAll('[data-paper-catalogue]').forEach(root => { if (root.closest('[data-merchant-shop]')) { legacyCategory(root); filter(root); } }));
  let pending = false;
  new MutationObserver(() => { if (pending) return; pending = true; queueMicrotask(() => { pending = false; init(); }); }).observe(document.body, { childList: true, subtree: true });
  window.BuyonikPaperCatalogue = { init };
  init();
})();


